import { BaseModel } from '../base-model';

export interface IDemandListing {
  Id?: number;
}

export class DemandListing extends BaseModel<IDemandListing> implements IDemandListing {
  Id?: number;
  
  constructor(option?: IDemandListing) {
    super(option);
    
  }
}